package fr.manyverse.app.infrastructure.cache

class UserConfigCache {
    private val acceptedUserIds = mutableSetOf<String>()

    fun isAccepted(userId: String): Boolean = userId in acceptedUserIds

    fun markAccepted(userId: String) {
        acceptedUserIds.add(userId)
    }

    fun clear() {
        acceptedUserIds.clear()
    }
}
